var map = {
	"./ei_transfers_icon.svg": 1118,
	"./mainNavigationChevron_icon.svg": 1119,
	"./schedule_icon.svg": 1120,
	"./sports-news_icon.svg": 1121,
	"./sports_icon.svg": 1122,
	"./table_icon.svg": 1123,
	"./transfers_icon.svg": 1124,
	"./worldnews_icon.svg": 1125
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1341;


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images ^\.\/.*_icon\.svg$
// module id = 1341
// module chunks = 33